import { render, staticRenderFns } from "./ProcessedDocsFilter.vue?vue&type=template&id=39a8b9be"
import script from "./ProcessedDocsFilter.vue?vue&type=script&lang=js"
export * from "./ProcessedDocsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a8b9be')) {
      api.createRecord('39a8b9be', component.options)
    } else {
      api.reload('39a8b9be', component.options)
    }
    module.hot.accept("./ProcessedDocsFilter.vue?vue&type=template&id=39a8b9be", function () {
      api.rerender('39a8b9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/ProcessedDocsFilter.vue"
export default component.exports